import React, { FC, useState } from "react";
import PageHeading from "shared/components/PageHeading";
import Tabs from "./Tabs";
import MetadataContainer from "./Tabs/Content/MetadataTags";
import TagsContainer from "./Tabs/Content/Tags";
import ThemeTagsContainer from "./Tabs/Content/ThemeTags";
import { TagsAndMetadataTabs } from "./Tabs/types";

const TagsAndMetadata: FC = () => {
  const [selectedTab, setSelectedTab] = useState(TagsAndMetadataTabs.Tags);

  return (
    <>
      <PageHeading />
      <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      {selectedTab === TagsAndMetadataTabs.Tags && <TagsContainer />}
      {selectedTab === TagsAndMetadataTabs.ThemeTags && <ThemeTagsContainer />}
      {selectedTab === TagsAndMetadataTabs.Metadata && <MetadataContainer />}
    </>
  );
};
export default TagsAndMetadata;
